import { DocumentModel } from './document.types';
import { validateAndSanitizeDocument } from './validation';

/**
 * Migration Registry to safely transform older schema revisions to the current schema.
 */
export function migrateDocument(rawJson: any): DocumentModel {
  if (!rawJson || typeof rawJson !== 'object') {
    throw new Error('Cannot migrate empty or invalid document payload.');
  }

  let doc = { ...rawJson };
  const sourceVersion = doc.schemaVersion || 0;

  // Apply sequential version migrations if needed in future
  if (sourceVersion < 1) {
    doc.schemaVersion = 1;
  }

  // Final check and sanitization
  const validation = validateAndSanitizeDocument(doc);
  if (!validation.isValid || !validation.sanitizedDocument) {
    throw new Error(`Document migration failed: ${validation.errors.join(', ')}`);
  }

  return validation.sanitizedDocument;
}
